import { Routes } from '@angular/router';

import { requireAuth } from '@core/auth/require-auth.guard';
import { requirePermission } from '@core/permissions/permission.guard';
import { RENT_UNIT_PERMISSION } from '@core/permissions/user-permission.enum';
import { loadLoginPage, loadResetPasswordPage } from '@shared/routing/lazy-routes';

export const routes: Routes = [
	{ path: '', pathMatch: 'full', redirectTo: 'login' },
	{
		path: '',
		loadComponent: () => import('@layouts/auth-layout/auth-layout').then((m) => m.AuthLayout),
		children: [
			{
				path: 'login',
				loadComponent: loadLoginPage,
			},
			{
				path: 'reset',
				loadComponent: loadResetPasswordPage,
			},
			{
				path: 'reset-password',
				loadComponent: loadResetPasswordPage,
			},
		],
	},
	{
		path: '',
		canActivate: [requireAuth],
		loadComponent: () => import('@layouts/main-layout/main-layout').then((m) => m.MainLayout),
		children: [
			{ path: '', pathMatch: 'full', redirectTo: 'dashboard' },
			{
				path: 'dashboard',
				loadChildren: () => import('@features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
			},
			{
				path: 'contacts',
				loadChildren: () => import('@features/contacts/contacts.routes').then((m) => m.CONTACTS_ROUTES),
			},
			{
				path: 'rent-unit',
				canActivate: [requirePermission(RENT_UNIT_PERMISSION, { silent: true })],
				loadChildren: () => import('@features/rent-unit/rent-unit.routes').then((m) => m.RENT_UNIT_ROUTES),
			},
			{
				path: 'operations',
				loadChildren: () => import('@features/operations/operations.routes').then((m) => m.OPERATIONS_ROUTES),
			},
			{
				path: 'reports',
				loadChildren: () => import('@features/reports/reports.routes').then((m) => m.REPORTS_ROUTES),
			},
			{
				path: 'access-control',
				loadChildren: () =>
					import('@features/access-control/access-control.routes').then((m) => m.ACCESS_CONTROL_ROUTES),
			},
			{
				path: 'configurations',
				loadChildren: () =>
					import('@features/configurations/configurations.routes').then((m) => m.CONFIGURATIONS_ROUTES),
			},
			{
				path: 'settings',
				loadChildren: () => import('@features/settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
			},
			{
				path: 'support',
				loadChildren: () => import('@features/support/support.routes').then((m) => m.SUPPORT_ROUTES),
			},
			{
				path: 'common-ui',
				loadChildren: () => import('@features/common-ui/common-ui.routes').then((m) => m.COMMON_UI_ROUTES),
			},
			{
				path: 'access-denied',
				loadComponent: () =>
					import('@features/access-denied/access-denied-page').then((m) => m.AccessDeniedPage),
			},
		],
	},
	{ path: '**', redirectTo: 'login' },
];
